import React from 'react';
import { TriggerWithProviders } from './TriggerWithProviders';
import { Entity } from '@backstage/catalog-model';

interface Props {
  entity: Entity;
}
export const TriggerCard = ({ entity }: Props) => {
  return <TriggerWithProviders entity={entity} />;
};
